import React, { useState } from 'react';

function RegisterForm({ onSignupSuccess }) {
    const [formData, setFormData] = useState({ name: '', style: '', weight: '' });
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        // 1. Grab Telegram WebApp interface
        const tg = window.Telegram?.WebApp;
        const telegramUser = tg?.initDataUnsafe?.user || {};

        // 2. Build the payload with TG identity
        const payload = {
            ...formData,
            tg_id: telegramUser.id || null,
            tg_username: telegramUser.username || null,
            tg_first_name: telegramUser.first_name || null
        };

        try {
            const response = await fetch('/api/register', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });

            if (response.ok) {
                // 3. Optional: Give the user a physical vibration in TG
                if (tg?.HapticFeedback) {
                    tg.HapticFeedback.notificationOccurred('success');
                }
                
                onSignupSuccess(formData.name);
            } else {
                alert('Registration failed. Please check your connection.');
            }
        } catch (err) {
            console.error('Submission Error:', err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <form className="register-form" onSubmit={handleSubmit}>
            <input
                type="text" placeholder="Full Name" required
                value={formData.name} onChange={e => setFormData({ ...formData, name: e.target.value })}
            />
            <input
                type="text" placeholder="Style (e.g. Kyokushin)" required
                value={formData.style} onChange={e => setFormData({ ...formData, style: e.target.value })}
            />
            <input
                type="number" placeholder="Weight (kg)" required
                value={formData.weight} onChange={e => setFormData({ ...formData, weight: e.target.value })}
            />
            <button type="submit" disabled={loading}>
                {loading ? 'PROCESSING...' : 'Confirm Entry'}
            </button>
        </form>
    );
}

export default RegisterForm;